import { shipmentApiClient } from '../shipmentApiClient'
import { recordShipmentVisitTimeEndpoint } from './endpoint'
import type {
  RecordShipmentVisitTimeParams,
  RecordShipmentVisitTimeRequest,
  RecordShipmentVisitTimeResponse,
} from './type'

export const recordShipmentVisitTime = async (
  params: RecordShipmentVisitTimeParams
): Promise<RecordShipmentVisitTimeResponse> => {
  const body: RecordShipmentVisitTimeRequest = {
    delivery_report_uid: params.deliveryReportUid,
    driver_phone: params.driverPhone,
    action: params.action,
  }
  const res = await shipmentApiClient.post<RecordShipmentVisitTimeResponse>(
    recordShipmentVisitTimeEndpoint(params.shipmentUid, params.visitId),
    body
  )
  return res.data
}
